import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=284a7fab"
import script from "./ServiceCard.vue?vue&type=script&lang=js"
export * from "./ServiceCard.vue?vue&type=script&lang=js"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=284a7fab&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.servis.leaseplan.cz/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('284a7fab')) {
      api.createRecord('284a7fab', component.options)
    } else {
      api.reload('284a7fab', component.options)
    }
    module.hot.accept("./ServiceCard.vue?vue&type=template&id=284a7fab", function () {
      api.rerender('284a7fab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/services/ServiceCard.vue"
export default component.exports